import { NewsAnnouncementCategories } from './news-announcement-categories';

export class NewsAnnouncementTitles {
  [category: string]: string;

  constructor() {
    this[NewsAnnouncementCategories.AgencySpecific] = 'Agency Specific';
    this[NewsAnnouncementCategories.GenericInformation] = 'Generic Information';
    this[NewsAnnouncementCategories.ProblemsAndFixes] = 'Problems And Fixes';
    this[NewsAnnouncementCategories.PublicUser] = 'Public User';
    this[NewsAnnouncementCategories.RecentSystemUpdates] = 'Recent System Updates';
  }
}
